import ModalAssignmentCommisions from './ModalAssignmentCommisions'

export default ModalAssignmentCommisions
